import useAxiosPrivate from "hooks/useAxiosPrivate";
import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { AlertState, DicBoTieuChiState } from "../../states";
import { API_ROUTES } from "../../utils/constants";

function GetBoTieuChi() {
  const axiosPrivateInstance = useAxiosPrivate();
  const setBoTieuChi = useSetRecoilState(DicBoTieuChiState);
  const setAlert = useSetRecoilState(AlertState);
  useEffect(() => {
    const fetchAllBoTieuChi = async () => {
      //danh sách bộ tiếu chí có nhombotieuchi_id
      try {
        const res = await axiosPrivateInstance.get(API_ROUTES.BOTIEUCHI);
        const data = res.data?.data;
        let dict = {};
        data?.forEach((item) => {
          dict[item?.id] = { ...item };
        });
        setBoTieuChi(dict);
      } catch (error) {
        setAlert({
          alert: true,
          message: error?.message || "Lỗi!",
          type: "error",
        });
        return;
      }
    };
    fetchAllBoTieuChi();
  }, []);
  return <></>;
}
export default GetBoTieuChi;
